import { render, staticRenderFns } from "./HorizontalNavGroup.vue?vue&type=template&id=79bc0e38&scoped=true"
import script from "./HorizontalNavGroup.vue?vue&type=script&lang=js"
export * from "./HorizontalNavGroup.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavGroup.vue?vue&type=style&index=0&id=79bc0e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bc0e38",
  null
  
)

export default component.exports